module.exports = __webpack_public_path__ + "files/6aebc8a4331d19618706a547d8cccffe.png";


//////////////////
// WEBPACK FOOTER
// ./images/office365Logo.png
// module id = 1118
// module chunks = 60